"use client"

import { useState } from "react"
import { submitCommand } from "../lib/api-client.ts"
import type { UserView } from "../lib/user-view.ts"
import styles from "./my-support.module.css"

type PreferencesViewModel = Extract<UserView, { readonly kind: "preferences" }>

export const PreferencesView = ({ view }: { readonly view: PreferencesViewModel }) => {
  const [draft, setDraft] = useState<{ readonly marketing?: boolean; readonly service?: boolean }>({})
  const [message, setMessage] = useState("")
  const [pending, setPending] = useState(false)
  const marketing = draft.marketing ?? view.preferences.marketing
  const service = draft.service ?? view.preferences.service

  const save = async (): Promise<void> => {
    setPending(true)
    setMessage("")
    try {
      await submitCommand("/web/preferences", { marketing, service })
      setMessage("알림 수신 설정을 저장했습니다.")
    } finally {
      setPending(false)
    }
  }

  return (
    <div className={styles["preferencesForm"]} data-preferences-form>
      <ul className={styles["preferencesList"]} data-preference-list>
        <li data-preference-row>
          <label className={styles["preferenceOption"]}>
            <input checked={service} data-preference="service" onChange={(event) => setDraft((current) => ({ ...current, service: event.target.checked }))} type="checkbox" />
            <span>
              <strong>서비스 알림</strong>
              <small className={styles["preferenceDescription"]}>전환, 교환, 상품권 상태를 알려드립니다.</small>
            </span>
          </label>
        </li>
        <li data-preference-row>
          <label className={styles["preferenceOption"]}>
            <input checked={marketing} data-preference="marketing" onChange={(event) => setDraft((current) => ({ ...current, marketing: event.target.checked }))} type="checkbox" />
            <span>
              <strong>혜택 알림</strong>
              <small className={styles["preferenceDescription"]}>새로운 혜택과 서비스 소식을 알려드립니다.</small>
            </span>
          </label>
        </li>
      </ul>
      <button aria-busy={pending} className="button primary" disabled={pending} onClick={() => void save()} type="button">
        {pending ? "설정 저장 중" : "설정 저장"}
      </button>
      {message.length === 0 ? null : (
        <p aria-live="polite" className={styles["successCopy"]}>
          {message}
        </p>
      )}
    </div>
  )
}
